import { useState } from "react"
import CartBandComponent from "../CartBand/CartBandComponent"
import "./DetailPageBannerHeaderComponent.scss"
import CartPopUpComponent from "../CartPopUp/CartPopUpComponent"
import TeaserBannerComponent from "./TeaserBannerComponent"
import _ from "lodash"
import { isAndroid, isIOS } from "react-device-detect";
import CONFIG from "../../../../utils/config"

const DetailPageBannerHeaderComponent = (props) => {

    const {
        bannerURL, btnName, productData, showCartBtn,
        showTagLine, showShareIcon, tagLine, setIsMainPageLoading,
        hasTeaser, rightTagLine, isMobile, entityType
    } = props

    const [isOpen, setIsOpen] = useState(false)
    console.log("productdata----",productData)

    return (
        <>
            {
                (hasTeaser && productData.teaserURL) ?
                <div className="teaser-view">
                    <TeaserBannerComponent 
                        productId={productData.id}
                        videoLink={productData.teaserURL}
                        videoLinkType={productData.teaserType}
                    />
                    <CartBandComponent 
                        showTagLine={showTagLine}
                        showBtn={showCartBtn}
                        showShareIcon={showShareIcon}
                        tagLine={tagLine}
                        rightTagLine={rightTagLine ? rightTagLine : ""}
                        btnName={btnName}
                        btnAction={() => {
                            if (isAndroid || isIOS) {
                                try {
                                  let obj = {
                                    message: "click-on-purchase",
                                    productId: productData?.id,
                                    amount: productData?.price,
                                    title: productData?.title,
                                    provider_name:
                                      productData?.provider?.provider_display_name,
                                    provider_img:
                                     productData?.provider?.provider_img,
                                    enrolledtextAmount:
                                      productData?.purchased_info
                                        ?.enrolled_text,
                                  };
                                  if (window.callbackHandler != undefined) {
                                    window.callbackHandler.postMessage(JSON.stringify(obj))
                                  }
                                  if (window.webkit != undefined) {
                                    if (
                                      window.webkit.messageHandlers.callbackHandler !=
                                      undefined
                                    ) {
                                      window.webkit.messageHandlers.callbackHandler.postMessage(
                                        JSON.stringify(obj)
                                      );
                                    }
                                  }
                                } catch (err) {
                                  console.log("error in sending message");
                                }
                              }
                            setIsOpen(true)}}
                    />
                </div>
                :
                bannerURL ? (
                    <div>
                        {/* <img className="w-100"
                            src={bannerURL}
                            alt={productData.title}
                        /> */}
                    {/* <div className="bannerrimg" style={{ backgroundImage: `url(${bannerURL})` }}></div> */}
                    <div className="bannerrimg">
                    <img src={bannerURL} alt="Banner" className="banner-image" />
                  </div>

                        <CartBandComponent 
                            showTagLine={showTagLine}
                            showBtn={showCartBtn}
                            showShareIcon={showShareIcon}
                            tagLine={tagLine}
                            rightTagLine={rightTagLine ? rightTagLine : ""}
                            btnName={btnName}
                            btnAction={() => {console.log("Click",isOpen);
                            if (isAndroid || isIOS) {
                                try {
                                  let obj = {
                                    message: "click-on-purchase",
                                    productId: productData?.id,
                                    amount: productData?.price,
                                    title: productData?.title,
                                    provider_name:
                                      productData?.provider?.provider_display_name,
                                    provider_img:
                                     productData?.provider?.provider_img,
                                    enrolledtextAmount:
                                      productData?.purchased_info
                                        ?.enrolled_text,
                                  };
                                  if (window.callbackHandler != undefined) {
                                    window.callbackHandler.postMessage(JSON.stringify(obj));
                                  }
                                  if (window.webkit != undefined) {
                                    if (
                                      window.webkit.messageHandlers.callbackHandler !=
                                      undefined
                                    ) {
                                      window.webkit.messageHandlers.callbackHandler.postMessage(
                                        JSON.stringify(obj)
                                      );
                                    }
                                  }
                                } catch (err) {
                                  console.log("error in sending message");
                                }
                              }
                            setIsOpen(true)}}
                        />
                    </div>
                ) : (
                    <div className="position-relative">
                        <div className="title-banner bk-grey empty-img w-100 d-flex justify-content-center align-items-center">
                            <p
                                dangerouslySetInnerHTML={{
                                    __html: productData.title,
                                }}
                            ></p>
                        </div>
                        <CartBandComponent 
                            showTagLine={showTagLine}
                            showBtn={showCartBtn}
                            showShareIcon={showShareIcon}
                            tagLine={tagLine}
                            rightTagLine={rightTagLine ? rightTagLine : ""}
                            btnName={btnName}
                            btnAction={() => {console.log("Click",isOpen);
                            if (isAndroid || isIOS) {
                                try {
                                  let obj = {
                                    message: "click-on-purchase",
                                    productId: productData?.id,
                                    amount: productData?.price,
                                    title: productData?.title,
                                    provider_name:
                                      productData?.provider?.provider_display_name,
                                    provider_img:
                                     productData?.provider?.provider_img,
                                    enrolledtextAmount:
                                      productData?.purchased_info
                                        ?.enrolled_text,
                                  };
                                  if (window.callbackHandler != undefined) {
                                    window.callbackHandler.postMessage(JSON.stringify(obj));
                                  }
                                  if (window.webkit != undefined) {
                                    if (
                                      window.webkit.messageHandlers.callbackHandler !=
                                      undefined
                                    ) {
                                      window.webkit.messageHandlers.callbackHandler.postMessage(
                                        JSON.stringify(obj)
                                      );
                                    }
                                  }
                                } catch (err) {
                                  console.log("error in sending message");
                                }
                              }
                            setIsOpen(true)}}
                        />
                    </div>
                )
            }
            <CartPopUpComponent
                isOpen={isOpen}
                productData={productData}
                closeAction={() => setIsOpen(false)}
                isSubscription={false}
                setMainPageLoading={setIsMainPageLoading}
                isMobile={isMobile}
                entityType={entityType}
            />
        </>
    )
}

export default DetailPageBannerHeaderComponent